import { NgModule } from '@angular/core';
import {FileSizePipe} from './file-size.pipe';
import {SafeUrlPipe} from './safe.url.pipe';

@NgModule({
    imports:        [],
    declarations:   [FileSizePipe, SafeUrlPipe],
    exports:        [FileSizePipe, SafeUrlPipe],
})
export class PipeModule {
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/services/pipe/pipe.module.ts